import { z } from 'zod';

export const CURRENCIES = ['USD', 'PYG', 'BRL'] as const;
export const CurrencySchema = z.enum(CURRENCIES);
export type CurrencyDTO = z.infer<typeof CurrencySchema>;

export const ROLES = [
  'gestor',
  'financeiro',
  'comercial',
  'cadastro',
  'colaborador',
  'consulta',
] as const;
export const RoleSchema = z.enum(ROLES);
export type RoleDTO = z.infer<typeof RoleSchema>;

/** Valor monetário em string decimal (nunca number/float — RNF-06). */
export const MoneyStringSchema = z
  .string()
  .regex(/^-?\d+(\.\d{1,4})?$/, 'valor monetário inválido (use decimal com até 4 casas)');

/** Percentual como decimal em [0,1) — ex.: 0.55 = 55%. */
export const RatioSchema = z.number().min(0).lt(1);

export const UuidSchema = z.string().uuid();

export const PaginationSchema = z.object({
  cursor: z.string().optional(),
  limit: z.coerce.number().int().min(1).max(100).default(20),
});
export type PaginationDTO = z.infer<typeof PaginationSchema>;
